module.exports = __webpack_public_path__ + "static/media/ID.8f5da81e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/ID.svg
// module id = 2170
// module chunks = 7